import { gql } from '@apollo/client'
import { useSearch } from '@btime/react-contexts'
import React from 'react'

import { mapPointsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useMapPointsState = () => React.useContext(Context) || {}
export const useMapPoints = () => useMapPointsState()?.mapPoints || []

const QUERY = gql`
  query MapPoints($page: Int, $search: String, $filter: MapPointFilter) {
    mapPoints(search: $search, filter: $filter, page: $page, sort: { field: NAME, type: ASC }) {
      id
      recordId
      recordType
      name
    }
  }
`

const MapPointLoader = ({ children, uncontrolledChildren }) => {
  const search = useSearch()
  const filter = { recordTypes: ['contracts'] }

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      filter: { ...filter }
    },
    client: mapPointsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default MapPointLoader
